/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForCorestack extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForCorestack");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForCorestack.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForCorestack>): ServiceAccountNativeDetailsForCorestack {
        let obj = Object.assign(new ServiceAccountNativeDetailsForCorestack(), model);
        ServiceAccountNativeDetailsForCorestack.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForCorestack>): ServiceAccountNativeDetailsForCorestack {
        if (!model) return null;
        return ServiceAccountNativeDetailsForCorestack.newInstance(<ServiceAccountNativeDetailsForCorestack> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForCorestack) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForCorestack.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForCorestack): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForCorestack.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
